import { $can, $hasFeature, $isRole } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_DataMenu',
  icon: 'navigation-data',
  index: '5',
  isAllowed: () => $can('viewProjectItem') || $can('Profile::Read'),
  subItems: [
    {
      sectionName: 'LeftNavigation_Users',
      index: '5-1',
      routeName: 'Profiles',
      subRouteName: [
        'ProfileCreate',
        'Profile',
        'ProfileOverview',
        'ProfileData',
        'ProfileCategorisedAttributes',
        'ProfileChannels',
        'ProfileMessages',
        'ProfileDevices',
        'ProfileTags',
        'ProfileSessions',
        'ProfileEvents',
        'ProfileLocations'
      ],
      isAllowed: () => $can('Profile::Read')
    },
    {
      sectionName: 'LeftNavigation_UserDevices',
      index: '5-2',
      routeName: 'Devices',
      subRouteName: ['Device'],
      isAllowed: () =>
        !(
          $isRole('csa') ||
          $isRole('consent-customer-service-agent') ||
          $isRole('consent-admin')
        ) && $can('Device::Read')
    },
    {
      sectionName: 'LeftNavigation_Audiences',
      index: '5-3',
      routeName: 'AudienceSegmentList',
      subRouteName: [
        'AudienceUserList',
        'AudienceRollingSegmentList',
        'AudienceUserListItems',
        'AudienceSportradarList',
        'AudienceSportradarListItems',
        'AudienceSuppressionList',
        'AudienceSuppressionListItems',
        'AudienceSegmentCreate',
        'AudienceSegmentUpdate',
        'AudienceSegmentCopy',
        'AudienceSegmentOverview',
        'AudienceSegmentEvaluations'
      ],
      isAllowed: () => $can('Segment::Read')
    },
    {
      sectionName: 'LeftNavigation_DataManager',
      index: '5-4',
      isAllowed: () =>
        $can('manageProjectTechnical') || $can('viewProjectTechnical'),
      routeName: 'DataManagerAttributesTags',
      subRouteName: [
        'DataManagerTagCategories',
        'DataManagerAggregates',
        'DataManagerEvents',
        'DataManagerMetrics',
        'DataManagerLocations',
        'DataManagerLocationsCreate',
        'DataManagerLocationsEdit',
        'DataManagerLocationsView'
      ]
    },
    {
      sectionName: 'LeftNavigation_ConsentManager',
      index: '5-8',
      isAllowed: () =>
        $can('SubscriptionPreference::Manage') &&
        $hasFeature('subscriptionPreferences'),
      routeName: 'ConsentManagerChannels',
      subRouteName: [
        'ConsentManagerChannels',
        'ConsentManagerSubscriptionPreferences'
      ]
    },
    {
      sectionName: 'LeftNavigation_Automations',
      index: '5-5',
      isAllowed: () => $can('manageAutomation') || $can('viewAutomation'),
      routeName: 'AutomationImports',
      subRouteName: [
        'AutomationImports',
        'AutomationExports',
        'AutomationExportView',
        'AutomationExportCreate',
        'AutomationImportCreate',
        'AutomationImportUpdate'
      ]
    },
    {
      sectionName: 'LeftNavigation_TaskHistory',
      index: '5-6',
      routeName: 'TaskHistory',
      subRouteName: ['TaskHistoryGroup', 'TaskHistoryView'],
      isAllowed: () => $can('viewTaskHistory')
    },
    {
      sectionName: 'LeftNavigation_AuditLog',
      isAllowed: () =>
        $hasFeature('auditLogCampaign') && $can('viewAuditLogMenu'),
      index: '5-7',
      routeName: 'CampaignAuditLog',
      subRouteName: ['CampaignAuditLog']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/data.js